import {classNames} from "shared/lib/classNames/classNames";
import cls from "./Socials.module.scss";
import YouTubeHover from "shared/assets/images/YouTubeHover.png";
import Youtube from "shared/assets/images/Youtube.png";
import TikTokHover from "shared/assets/images/TikTokHover.png";
import TikTok from "shared/assets/images/TikTok.png";
import FacebookHover from "shared/assets/images/FacebookHover.png";
import Facebook from "shared/assets/images/Facebook.png";
import InstagramHover from "shared/assets/images/InstagramHover.png";
import Instagram from "shared/assets/images/Instagram.png";

interface SocialsProps {
    className?: string;
}

const Socials = ({ className }: SocialsProps) => {
    return (
        <div className={classNames(cls.Socials, {}, [className])}>
            <a href="" className={cls.Socials__link} onClick={(e) => e.preventDefault()}>
                <img
                    className={
                        classNames(cls.Socials__img, {}, [cls.Socials__img_opacity])}
                    src={YouTubeHover} alt=""
                />
                <img src={Youtube} className={cls.Socials__img} alt=""/>
            </a>
            <a href="" className={cls.Socials__link} onClick={(e) => e.preventDefault()}>
                <img
                    className={
                        classNames(cls.Socials__img, {}, [cls.Socials__img_opacity])}
                    src={TikTokHover} alt=""
                />
                <img src={TikTok} className={cls.Socials__img} alt=""/>
            </a>
            <a href="" className={cls.Socials__link} onClick={(e) => e.preventDefault()}>
                <img
                    className={
                        classNames(cls.Socials__img, {}, [cls.Socials__img_opacity])}
                    src={FacebookHover} alt=""
                />
                <img src={Facebook} className={cls.Socials__img} alt=""/>
            </a>
            <a href="" className={cls.Socials__link} onClick={(e) => e.preventDefault()}>
                <img
                    className={
                        classNames(cls.Socials__img, {}, [cls.Socials__img_opacity])}
                    src={InstagramHover} alt=""
                />
                <img src={Instagram} className={cls.Socials__img} alt=""/>
            </a>
        </div>
    )
};

export default Socials;